/**
 * Rupee amounts for KPI headlines: en-IN grouping, 2 decimals, crore unit.
 * 1 Cr = 10,000,000 (1,00,00,000).
 */
export function formatKpiCrores(val) {
  const crores = Number(val || 0) / 1e7;
  const formatted = new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(crores);
  return `₹ ${formatted} Cr`;
}

const in2 = (n) => new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
const in0 = (n) => new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(n);

/**
 * KPI headline amounts from thousands through crores: uses Cr ≥ 1 Cr, Lakhs ≥ 1 L, else full rupees (en-IN).
 * Avoids tiny values showing as "₹ 0.00 Cr".
 */
export function formatKpiAdaptiveINR(val) {
  const raw = Number(val || 0);
  const abs = Math.abs(raw);
  const sign = raw < 0 ? '-' : '';
  if (abs >= 1e7) return `${sign}₹ ${in2(abs / 1e7)} Cr`;
  if (abs >= 1e5) return `${sign}₹ ${in2(abs / 1e5)} L`;
  return `${sign}₹ ${in0(abs)}`;
}
